import { render, staticRenderFns } from "./SupportingDocumentsHistory.vue?vue&type=template&id=cd9eb20a&scoped=true"
import script from "./SupportingDocumentsHistory.vue?vue&type=script&lang=ts"
export * from "./SupportingDocumentsHistory.vue?vue&type=script&lang=ts"
import style0 from "./SupportingDocumentsHistory.vue?vue&type=style&index=0&id=cd9eb20a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd9eb20a",
  null
  
)

export default component.exports